import { useQuery } from "@apollo/client";
import { GET_ULTIMOS_INGRESOS, UltimosIngresosResponse } from "./graphql";

const useUltimosIngresos = () => {
    const { data, loading, error } = useQuery<UltimosIngresosResponse>(GET_ULTIMOS_INGRESOS, {
        fetchPolicy: "cache-first",
        errorPolicy: "all" // Continue even if there are GraphQL errors
    });

    return {
        loading,
        data: data?.ultimosIngresos?.items || [],
        error,
        hasProperties: !!(data?.ultimosIngresos?.items?.length)
    };
};

export { useUltimosIngresos };
